export default "__VITE_ASSET__bc15eabb__"